import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ExcelService } from 'src/app/services/excel.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {

  public users: [];

  constructor(private router: Router, public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private excelService: ExcelService, public themeService: ThemeService) { }

  ngOnInit() {
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.users, 'Users');
  }

}
